import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleRequired(event) {
    const hasParent = event.target.value !== ""
    const star = document.getElementById("area-code-required-star")
    const help = document.getElementById("area-code-help")

    if (star) star.style.display = hasParent ? "" : "none"
    if (help) help.style.display = hasParent ? "none" : ""
  }
}
